import React from 'react';
import {
  AddressesPage,
  DashboardPage,
  DeliveryDetailPage,
  DeliveryPage,
  DispatchDetailPage,
  DispatchSchedulesPage,
  DispatchesPage,
  ExportTemplatesPage,
  HubsPage,
  InboundPage,
  InvoicesPage,
  NotFoundPage,
  CodOrdersPage,
  PackagesPage,
  ScheduledInstantPage,
  ShipmentsPage,
  UjpConfigPage,
  UjpPage,
  WarehousePage,
  WorkflowsPage,
  ZonesPage,
  ProvidersPage,
  ProviderDetailPage,
  RoutePlannerPage,
  UjpTariffsPage,
  UjpMastersPage,
} from '@/pages';
import { RouteConfig } from '@/types';
import { APP_CONFIG } from '@/config/app';

export const PROVIDERS_ROUTE: RouteConfig = {
  path: '/providers',
  element: <ProvidersPage />,
  title: 'Clients',
  icon: 'ri-building-2-line',
};

export const PROVIDER_DETAIL_ROUTE: RouteConfig = {
  path: '/providers/:id',
  element: <ProviderDetailPage />,
  title: 'Client Detail',
};

export const PROVIDERS_ALIAS_ROUTE: RouteConfig = {
  path: '/provider',
  element: <ProvidersPage />,
  title: 'Clients',
};

export const PROVIDER_DETAIL_ALIAS_ROUTE: RouteConfig = {
  path: '/provider/:id',
  element: <ProviderDetailPage />,
  title: 'Client Detail',
};

export const DASHBOARD_ROUTE: RouteConfig = {
  path: '/dashboard',
  element: <DashboardPage />,
  title: 'Docking Dashboard',
  icon: 'ri-dashboard-2-line',
};

export const INVOICES_ROUTE: RouteConfig = {
  path: '/invoices',
  element: <InvoicesPage />,
  title: 'Invoices',
  icon: 'ri-file-list-3-line',
};

export const SHIPMENTS_ROUTE: RouteConfig = {
  path: '/shipments',
  element: <ShipmentsPage />,
  title: 'Shipments',
  icon: 'ri-archive-line',
};

export const UJP_ROUTE: RouteConfig = {
  path: '/ujp',
  element: <UjpPage />,
  title: 'UJP',
  icon: 'ri-wallet-3-line',
};

/** The per-client rule behind every UJP estimate (CR-D7); approver-editable. */
export const UJP_CONFIG_ROUTE: RouteConfig = {
  path: '/ujp/config',
  element: <UjpConfigPage />,
  title: 'Konfigurasi UJP client',
};

/** The per-client revenue tariff + rings (CR-4); approver-editable. */
export const UJP_TARIFFS_ROUTE: RouteConfig = {
  path: '/ujp/tariffs',
  element: <UjpTariffsPage />,
  title: 'Tarif & margin UJP',
};

/** UJP masters — vehicles, dated energy prices, subcon vendors (TODO-22); approver-editable. */
export const UJP_MASTERS_ROUTE: RouteConfig = {
  path: '/ujp/masters',
  element: <UjpMastersPage />,
  title: 'Master UJP',
};

export const PACKAGES_ROUTE: RouteConfig = {
  path: '/packages',
  element: <PackagesPage />,
  title: 'Packages',
  icon: 'ri-box-3-line',
};

export const COD_ORDERS_ROUTE: RouteConfig = {
  path: '/cod-orders',
  element: <CodOrdersPage />,
  title: 'COD Reconciliation',
  icon: 'ri-money-dollar-circle-line',
};

export const DELIVERY_ROUTE: RouteConfig = {
  path: '/delivery',
  element: <DeliveryPage />,
  title: 'Delivery',
  icon: 'ri-truck-line',
};

export const DISPATCHES_ROUTE: RouteConfig = {
  path: '/dispatches',
  element: <DispatchesPage />,
  title: 'Dispatches',
  icon: 'ri-send-plane-line',
};

export const DISPATCH_DETAIL_ROUTE: RouteConfig = {
  path: '/dispatches/:id',
  element: <DispatchDetailPage />,
  title: 'Dispatch Detail',
};

export const DISPATCH_SCHEDULES_ROUTE: RouteConfig = {
  path: '/dispatch-schedules',
  element: <DispatchSchedulesPage />,
  title: 'Jadwal Dispatch',
  icon: 'ri-calendar-schedule-line',
};

export const DELIVERY_DETAIL_ROUTE: RouteConfig = {
  path: '/delivery/:id',
  element: <DeliveryDetailPage />,
  title: 'Delivery Detail',
};

export const INBOUND_ROUTE: RouteConfig = {
  path: '/inbound',
  element: <InboundPage />,
  title: 'Inbound',
  icon: 'ri-archive-drawer-line',
};

export const HUBS_ROUTE: RouteConfig = {
  path: '/hubs',
  element: <HubsPage />,
  title: 'Hubs',
  icon: 'ri-building-2-line',
};

export const ZONES_ROUTE: RouteConfig = {
  path: '/zones',
  element: <ZonesPage />,
  title: 'Zones',
  icon: 'ri-shape-2-line',
};

export const SCHEDULED_INSTANT_ROUTE: RouteConfig = {
  path: '/scheduled-instant',
  element: <ScheduledInstantPage />,
  title: 'Scheduled Instant',
  icon: 'ri-calendar-schedule-line',
};

export const ADDRESSES_ROUTE: RouteConfig = {
  path: '/addresses',
  element: <AddressesPage />,
  title: 'Addresses',
  icon: 'ri-map-pin-line',
};

export const WORKFLOWS_ROUTE: RouteConfig = {
  path: '/workflows',
  element: <WorkflowsPage />,
  title: 'Workflows',
  icon: 'ri-flow-chart',
};

export const ROUTE_PLANNER_ROUTE: RouteConfig = {
  path: '/route-planner',
  element: <RoutePlannerPage />,
  title: 'Route Planner',
  icon: 'ri-route-line',
};

export const EXPORT_TEMPLATES_ROUTE: RouteConfig = {
  path: '/export-templates',
  element: <ExportTemplatesPage />,
  title: 'Export Templates',
  icon: 'ri-file-transfer-line',
};

/**
 * WMS v2 — the feature owns its child routes (src/pages/warehouse/routes.tsx):
 * stock, storage, sku, outbound-request, picking, shipping, purchase-order,
 * inbound-request, goods-receipt. `/warehouse` redirects to `/warehouse/stock`.
 */
export const WAREHOUSE_ROUTE: RouteConfig = {
  path: '/warehouse/*',
  element: <WarehousePage />,
  title: 'Warehouse',
  icon: 'ri-store-3-line',
};

export const routes: RouteConfig[] = [
  DASHBOARD_ROUTE,
  INVOICES_ROUTE,
  SHIPMENTS_ROUTE,
  UJP_ROUTE,
  UJP_CONFIG_ROUTE,
  UJP_TARIFFS_ROUTE,
  UJP_MASTERS_ROUTE,
  PACKAGES_ROUTE,
  DISPATCHES_ROUTE,
  DISPATCH_DETAIL_ROUTE,
  DISPATCH_SCHEDULES_ROUTE,
  INBOUND_ROUTE,
  DELIVERY_ROUTE,
  DELIVERY_DETAIL_ROUTE,
  COD_ORDERS_ROUTE,
  HUBS_ROUTE,
  ZONES_ROUTE,
  SCHEDULED_INSTANT_ROUTE,
  ADDRESSES_ROUTE,
  WORKFLOWS_ROUTE,
  ROUTE_PLANNER_ROUTE,
  WAREHOUSE_ROUTE,
  EXPORT_TEMPLATES_ROUTE,
  PROVIDERS_ROUTE,
  PROVIDER_DETAIL_ROUTE,
  PROVIDERS_ALIAS_ROUTE,
  PROVIDER_DETAIL_ALIAS_ROUTE,
  {
    path: '/',
    element: <InvoicesPage />,
    title: APP_CONFIG.name,
  },
  {
    path: '*',
    element: <NotFoundPage />,
    title: 'Page Not Found',
  },
];

export const getPageTitle = (pathname: string): string => {
  const route = routes.find(
    (route) =>
      route.path === pathname ||
      (route.path.endsWith('/*') &&
        (pathname === route.path.slice(0, -2) ||
          pathname.startsWith(route.path.slice(0, -1))))
  );
  return route?.title || APP_CONFIG.name;
};
